import EmptyStateHappy from '../assets/illustrations/empty-state-happy'
import EmptyStateNoResult from '../assets/illustrations/empty-state-noresult'
import EmptyStateWaiting from '../assets/illustrations/empty-state-waiting'
import Export from '../assets/illustrations/export'
import Scanner from '../assets/illustrations/scanner'
import Support from '../assets/illustrations/support'

const Illustrations = {
  EmptyStateHappy,
  EmptyStateNoResult,
  EmptyStateWaiting,
  Scanner,
  Export,
  Support,
}

export default Illustrations
